import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { couriersActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";
import { apiConstants } from "../../../../../../constants";
import { authHeader } from "../../../../../../helpers";
import AlertToast from "../../../../../common/Toast";
import AlertToastSuccess from "../../../../../common/ToastSuccess";

import {
  useGetLibraryQuery,
} from "../../../../../../services/api/embroidery-library";

const EmbroideryLibraryList = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "organization_name",
      headerName: "Org Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "design_name",
      headerName: "Design Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "disk_name",
      headerName: "Disk Number",
      minWidth: 200,
      flex: 1,
    },

  ];

  const recordIdentifier = "name";

  const { data, isLoading } = useGetLibraryQuery();
  console.log("Embroidery Library Data:", data);
  
  return (
    <Box>
      <DataTable
        loading={isLoading}
        rows={data || []}
        columns={columns}
        recordIdentifier={recordIdentifier}
        actionIdentifier="embroidery_library"
        isEnabledEdit={true}
        hasSeparateView={{ active: true, param: "id", suffix: "/view" }}
      />
    </Box>
  );
};

export default EmbroideryLibraryList;
